/**
=========================================================
* Argon Dashboard 2 PRO MUI - v3.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-mui
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";

// @mui material components
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Stepper from "@mui/material/Stepper";
import { useEffect, useState } from "react";

// Argon Dashboard 2 PRO MUI components
import ArgonBox from "components/ArgonBox";
import ArgonButton from "components/ArgonButton";

// Argon Dashboard 2 PRO MUI example components
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";

// NewProduct page components
import BasicInfo from "layouts/pages/account/settings/components/BasicInfo";

import BusinessPageTemplate from "./BusinessTemplate";

function EditBusinessInfo() {
  return (
    <BusinessPageTemplate title="Business Information">
      <BasicInfo />
    </BusinessPageTemplate>
  );
}

export default EditBusinessInfo;
